export default "__VITE_PUBLIC_ASSET__47c293a5__"